import React from "react";
import { useStyles } from "./Style";
import Expiry from "images/newEvents.png";
import Button from "storybookComponents/Button";
import { CloseIcon } from "icons"
import moment from "moment";
import localStorage from "common/localStorage"

const ExpiryNotificationPopup = (props) => {
  const classes = useStyles();
  const [hide, setHide] = React.useState(false)
  const [diff, setDiff] = React.useState(1)
  const handleClose = () => {
    let tomorrow = new Date();
    tomorrow.setHours(24, 0, 0, 0)
    localStorage.setItem("expiry-popup-hyevents", "1", tomorrow)
    setHide(true)
  }
  const handleClick = () => {
    window.open(process.env.REACT_APP_JAI_hostName + "/" + props.propertyId + "/events", "_blank");
  }

  const calculateDiff = (expiredAt) => {
    let a = moment().set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    });
    let b = moment(expiredAt)
    setDiff(Math.abs(a.diff(b, 'days')))
  }

  React.useEffect(() => {
    calculateDiff(props.expiredAt)
  }, [props.expiredAt])
  if (hide || localStorage.getItem("expiry-popup-hyevents")) return null
  return (
    <div className={classes.expairyPopUpContainer}>
      <div className={classes.closeIcon} onClick={handleClose}><CloseIcon /></div>
      <div className={classes.popHeader}>{props.expiredAt ? `hyEvents expires in ${diff} ${diff >= 2 ? "days" : "day"}!` : "Events-New And Improved"}</div>
      <div className={classes.popTitle}>{props.expiredAt ? <>Try new and improved <span className={classes.highlight}>Journey AI - Events</span> now as hyEvents will no longer be available from {moment(props.expiredAt).format("MMM DD, YYYY")}.</> : "It's Easy And fun to create Events Now"}</div>
      <img className={classes.imageDiv} src={Expiry} alt="error" />
      <Button onClick={handleClick} className={classes.tryButton}>{props.expiredAt ? "Go to Events Now" : "Try It Now"}</Button>

    </div >
  );
};
export default ExpiryNotificationPopup; 
